import { WalletBase } from '../WalletBase';
import { ExtendedWalletType, ISignResult } from '../types';

export class UnisatWallet extends WalletBase {
  authType = ExtendedWalletType.UNISAT;
  protocolTag = 'unisat';
  app?: {
    name: string;
    icon: string;
  };

  init(): void {
    if ('unisat' in window) {
      const provider = window.unisat;

      this.provider = provider;
    } else {
      window.open('https://hk.unisat.io/download', `_blank`);
    }
  }
  async connect(): Promise<boolean> {
    const provider = this.provider;
    if (!provider) return false;
    const accounts = await provider?.requestAccounts();
    const publicKey = await provider?.getPublicKey();
    console.log(accounts);
    this.isConnected = true;

    this.address = accounts[0];
    this.publicKey = publicKey;
    return true;
  }

  async sign(message: string): Promise<ISignResult> {
    const signature = await this.provider?.signMessage(message);
    console.log(signature);
    return {
      message,
      signature: signature
    };
  }
}
